import { LegalDocument } from "@/components/LegalDocument";
import { Seo } from "@/components/Seo";
import blocks from "@/legal/refund.json";

const Refund = () => (
  <>
    <Seo
      title="Refund Policy — DELSHA"
      description="The official DELSHA Refund Policy — how cancellations and refunds work for card and cash driving lesson bookings."
    />
    <LegalDocument blocks={blocks} testId="refund" />
  </>
);

export default Refund;
